var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Css3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface61185911"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.156864%,13.333334%,81.568629%)",
      fillOpacity: 1
    },
    d: "M 25.429688 3.332031 C 25.238281 3.121094 24.96875 3 24.683594 3 L 5.316406 3 C 5.03125 3 4.761719 3.121094 4.570312 3.332031 C 4.382812 3.546875 4.292969 3.828125 4.324219 4.109375 L 6.523438 23.933594 C 6.570312 24.335938 6.855469 24.671875 7.242188 24.785156 L 14.722656 26.921875 C 14.8125 26.945312 14.90625 26.960938 15 26.960938 C 15.089844 26.960938 15.183594 26.945312 15.273438 26.921875 L 22.753906 24.785156 C 23.144531 24.671875 23.429688 24.335938 23.472656 23.933594 L 25.675781 4.109375 C 25.707031 3.828125 25.617188 3.546875 25.429688 3.332031 Z M 20.515625 13.074219 L 20.070312 20.359375 L 15.03125 22.007812 L 9.992188 20.359375 L 9.804688 16.875 L 12.351562 16.875 L 12.417969 18.460938 L 15.03125 19.347656 L 17.648438 18.460938 L 17.839844 15.609375 L 12.226562 15.609375 L 12.097656 13.074219 L 17.964844 13.074219 L 18.15625 10.539062 L 9.355469 10.539062 L 9.164062 8.007812 L 20.835938 8.007812 Z M 20.515625 13.074219 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Css3);
export default __webpack_public_path__ + "static/media/icons8-css3.31225e58ed5878d53b016dde57b4b8f1.svg";
export { ForwardRef as ReactComponent };